import { Controller } from '@hotwired/stimulus'

// Base class for all Stimulus controllers
// Shared lifecycle methods or utilities can be added here as needed
export default class extends Controller {
}
